var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11845_69905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36416 2.09961L15.1202 12.0689C15.2079 12.221 15.2541 12.3934 15.2541 12.5689C15.2541 12.7445 15.2079 12.9169 15.1202 13.0689C15.0324 13.221 14.9062 13.3472 14.7542 13.435C14.6021 13.5227 14.4297 13.5689 14.2542 13.5689H2.74216C2.56663 13.5689 2.39419 13.5227 2.24217 13.435C2.09016 13.3472 1.96392 13.221 1.87616 13.0689C1.78839 12.9169 1.74219 12.7445 1.74219 12.5689C1.74219 12.3934 1.78839 12.221 1.87616 12.0689L7.63216 2.09961C8.01683 1.43294 8.97883 1.43294 9.36416 2.09961ZM8.49816 3.26628L3.3195 12.2356H13.6768L8.49816 3.26628ZM8.49816 10.0009C8.67497 10.0009 8.84454 10.0712 8.96957 10.1962C9.09459 10.3212 9.16483 10.4908 9.16483 10.6676C9.16483 10.8444 9.09459 11.014 8.96957 11.139C8.84454 11.264 8.67497 11.3343 8.49816 11.3343C8.32135 11.3343 8.15178 11.264 8.02676 11.139C7.90173 11.014 7.8315 10.8444 7.8315 10.6676C7.8315 10.4908 7.90173 10.3212 8.02676 10.1962C8.15178 10.0712 8.32135 10.0009 8.49816 10.0009ZM8.49816 5.33428C8.67497 5.33428 8.84454 5.40451 8.96957 5.52954C9.09459 5.65456 9.16483 5.82413 9.16483 6.00094V8.66761C9.16483 8.84442 9.09459 9.01399 8.96957 9.13901C8.84454 9.26404 8.67497 9.33428 8.49816 9.33428C8.32135 9.33428 8.15178 9.26404 8.02676 9.13901C7.90173 9.01399 7.8315 8.84442 7.8315 8.66761V6.00094C7.8315 5.82413 7.90173 5.65456 8.02676 5.52954C8.15178 5.40451 8.32135 5.33428 8.49816 5.33428Z",
    fill: "#D7221D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11845_69905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c91f4f214e5cf2584410d8996e673cb3.svg";
export { ForwardRef as ReactComponent };